module.exports = __webpack_public_path__ + "static/media/sherwin_williams.cb13221c.png";